import { useContext, useEffect, useRef } from 'react';

import { ModalContext } from '../ModalManager';
import { subscribePublicationCurfew } from '../../../libs/publicationCurfew';
import { PUBLICATION_CURFEW_MODAL } from '../../../hooks/usePublicationCurfew';

/**
 * Filet de sécurité du couvre-feu : ouvre la modale quand l'API a refusé une publication
 * (code `PUBLICATION_CURFEW`), pour les chemins qui ne sont pas gatés au clic — éditeurs
 * d'articles, formulaires de forum, ou simplement 20h qui sonne pendant la saisie.
 *
 * Ne rend rien ; à monter une seule fois, SOUS le ModalManager (cf. src/index.js). L'émetteur est
 * le MutationCache de React Query, qui vit hors de l'arbre React et ne peut pas ouvrir de modale
 * lui-même.
 */
const PublicationCurfewListener = () => {
    const { openModal } = useContext(ModalContext);

    // Le ModalManager recrée `openModal` à chaque rendu : passer par une ref évite de
    // désabonner/réabonner en boucle.
    const openModalRef = useRef(openModal);
    openModalRef.current = openModal;

    // Le refus de l'API porte ses propres bornes (`errors.curfew`) : on les transmet à la modale,
    // qui les préférera au cache `currentUser` pour afficher les horaires.
    useEffect(() => subscribePublicationCurfew(
        (curfew) => openModalRef.current(PUBLICATION_CURFEW_MODAL, { curfew })
    ), []);

    return null;
};

export default PublicationCurfewListener;
